import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { XIcon, MenuIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useDonateByMail } from '../contexts/DonateByMailContext';
const Navigation = () => {
  const {
    openDonateByMail
  } = useDonateByMail();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  // Track scroll position
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const navigationLinks = [{
    path: '/',
    label: 'Home'
  }, {
    path: '/about',
    label: 'About Us'
  }, {
    path: '/programs',
    label: 'Programs'
  }, {
    path: '/team',
    label: 'Meet the Team'
  }, {
    path: '/training-center',
    label: 'Training Center'
  }, {
    path: '/roadmap',
    label: 'Roadmap'
  }, {
    path: '/support',
    label: 'Support'
  }, {
    path: '/contact',
    label: 'Contact Us'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 w-full px-4 py-4 sm:py-6 transition-all duration-300 ${scrolled || !isHomePage ? 'bg-white shadow-md' : 'bg-transparent'}`} data-id="element-151" data-mp="webh7cyx8vhx">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-152" data-mp="157nejx43xdx9">
        <AnimatePresence data-id="element-153" data-mp="1a4x37ajo9lk1">
          {(scrolled || !isHomePage) && <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.9
        }} transition={{
          duration: 0.3
        }} data-id="element-154" data-mp="1f5l1mha8d4oa">
              <Link to="/" className="flex-shrink-0" data-id="element-155" data-mp="146bslcei2t90">
                <img src="https://cdn.magicpatterns.com/uploads/gznFEFjybyktnP4QK9mR3y/new_ictf_logo_real_blue.png" alt="Israeli Civilian Training Foundation Logo" className="h-8 sm:h-10 w-auto" data-id="element-156" data-mp="147wlyyp2w65a" />
              </Link>
            </motion.div>}
        </AnimatePresence>
        <nav className="hidden md:flex items-center justify-center space-x-2 flex-grow" data-id="element-157" data-mp="1n57hc87laffg">
          {navigationLinks.map(link => <Link key={link.path} to={link.path} className={`${isHomePage && !scrolled ? 'text-white hover:text-blue-200' : 'text-israel-blue hover:text-blue-700'} transition-all transform hover:-translate-y-1 px-4 lg:px-5 py-2 font-light tracking-normal rounded-lg hover:bg-white/10`} data-id="element-158" data-mp="1i64d2pzfod8j">
              {link.label}
            </Link>)}
        </nav>
        <AnimatePresence data-id="element-159" data-mp="24d774ibvu4n1">
          {scrolled && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3
        }} className="hidden md:flex items-center gap-2" data-id="element-160" data-mp="1ppvro5cky0hn">
              <button type="button" onClick={openDonateByMail} className="inline-block px-4 py-2 bg-white text-israel-blue font-medium rounded-lg border border-israel-blue hover:bg-blue-50 transition-colors duration-200 whitespace-nowrap" data-id="element-161" data-mp="16scjt51uynwt">
                Donate by Mail
              </button>
              <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="inline-block px-4 py-2 bg-israel-blue text-white font-medium rounded-lg border border-israel-blue hover:bg-israel-blue-light transition-colors duration-200 shadow-md whitespace-nowrap" data-id="element-162" data-mp="1601lvzqfvymi">
                Donate Online
              </a>
            </motion.div>}
        </AnimatePresence>
        <button className={`md:hidden relative z-50 p-2 ${isHomePage && !scrolled ? 'text-white' : 'text-israel-blue'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-163" data-mp="iagy93jccd6w">
          {isMobileMenuOpen ? <XIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-164" data-mp="4caaig83vtky" /> : <MenuIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-165" data-mp="4dlccahzqr9f" />}
        </button>
      </div>
      <div className={`fixed inset-0 bg-black/20 z-40 md:hidden transition-opacity duration-300 ${isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-166" data-mp="3vkedxfgp4seh" />
      <div className={`fixed top-0 right-0 w-[250px] sm:w-[280px] h-full bg-white z-40 transform transition-transform duration-300 ease-in-out md:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-167" data-mp="2kxnlluuwrauo">
        <div className="flex flex-col p-5 sm:p-6 pt-16 sm:pt-20" data-id="element-168" data-mp="1sb2y55hjziwe">
          <nav className="flex flex-col space-y-3 sm:space-y-4" data-id="element-169" data-mp="1x831h8n0q7jt">
            {navigationLinks.map(link => <Link key={link.path} to={link.path} className="text-gray-800 hover:text-israel-blue hover:bg-gray-100 transition-colors px-3 sm:px-4 py-2 sm:py-3 rounded-lg font-light tracking-normal" onClick={() => setIsMobileMenuOpen(false)} data-id="element-170" data-mp="21955e2rvr7s4">
                {link.label}
              </Link>)}
            <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="mt-3 sm:mt-4 text-center px-3 sm:px-4 py-2 sm:py-3 bg-israel-blue text-white font-medium rounded-lg hover:bg-israel-blue-light transition-all duration-300" onClick={() => setIsMobileMenuOpen(false)} data-id="element-171" data-mp="2gurdkdsvf36k">
              Donate Online
            </a>
            <button type="button" className="text-center px-3 sm:px-4 py-2 sm:py-3 bg-white text-israel-blue font-medium rounded-lg border border-israel-blue hover:bg-blue-50 transition-colors duration-200" onClick={() => {
            setIsMobileMenuOpen(false);
            openDonateByMail();
          }} data-id="element-172" data-mp="1xyriuv8idlja">
              Donate by Mail
            </button>
          </nav>
        </div>
      </div>
    </header>;
};
export default Navigation;